import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { CircularProgressWrapper } from 'hb-react/backoffice/components/CircularProgressWrapper';

export const ScreenUIWrapper = styled(Box).attrs({
  py: 5,
  alignItems: 'center',
  flexWrap: 'wrap',
})``;

export const ScreenUITitle = styled(Box)`
  ${({ theme }) =>
    css`
      * {
        font-weight: ${theme.fontWeights[2]} !important;
        line-height: ${theme.lineHeights[6]} !important;
        font-size: ${theme.fontSizes[7]} !important;
      }
    `}
`;

export const ScreenUIBox = styled(Box).attrs({
  display: 'block',
  flexDirection: 'column',
  ml: 3,
})``;

export const ScreenUIButton = styled(Box).attrs(({ m }: { m?: string }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  m,
}))`
  * {
    width: auto !important;
  }
`;

export const CircularProgressBarWrapper = styled(CircularProgressWrapper).attrs(
  {
    position: 'absolute',
  },
)`
  position: absolute;
  max-width: inherit;
`;
